var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B233"
    },
    d: "M460.811,102.4l-59.167-22.756l30.094,113.778l65.674-22.756  C488.676,145.95,476.264,122.971,460.811,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC566"
    },
    d: "M256,0l168.4,102.4h36.411C414.107,40.223,339.752,0,256,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B233"
    },
    d: "M443.733,233.244l-11.994,130.844l65.674-22.756C506.848,314.641,512,285.924,512,256   L443.733,233.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B233"
    },
    d: "M424.4,386.844l-73.142,81.159l24.208,14.449c33.559-17.741,62.703-42.71,85.345-72.852   L424.4,386.844z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC566"
    },
    d: "M307.2,221.867L5.126,307.2c10.849,53.444,38.354,100.831,76.852,136.533l292.036,24.27   c19.337-15.953,36.375-35.716,50.386-58.403l30.094-68.267c7.759-26.692,11.994-55.41,11.994-85.333L307.2,221.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC566"
    },
    d: "M497.413,170.667h-42.918v42.667L466.489,256H512C512,226.076,506.848,197.359,497.413,170.667z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD999"
    },
    d: "M454.494,170.667L424.4,102.4C385.998,40.223,324.863,0,256,0C132.149,0,28.846,87.95,5.126,204.8  L307.2,256h159.289C466.489,226.076,462.253,197.359,454.494,170.667z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FD5F6E"
    },
    cx: 256,
    cy: 51.2,
    r: 17.067
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FA9647"
    },
    d: "M454.494,341.333L424.4,375.467V409.6h36.411c15.452-20.571,27.864-43.55,36.601-68.267H454.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B233"
    },
    d: "M79.644,375.467c0,18.852,15.281,34.133,34.133,34.133H424.4  c12.706-20.571,22.91-43.55,30.094-68.267H113.778C94.926,341.333,79.644,356.615,79.644,375.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC566"
    },
    d: "M170.667,102.4c-18.852,0-34.133,15.281-34.133,34.133s15.281,34.133,34.133,34.133h283.828  c-7.184-24.717-17.39-47.696-30.094-68.267H170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD999"
    },
    d: "M374.014,468.003l-112.568,43.913c41.123-0.86,79.859-11.404,114.021-29.464v-4.585  C375.467,474.436,374.955,471.126,374.014,468.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEECCC"
    },
    d: "M341.333,443.733H81.978C127.652,486.092,188.796,512,256,512c1.822,0,3.633-0.047,5.445-0.084  c37.054-1.145,71.72-13.95,101.631-35.491c3.719-2.678,7.369-5.48,10.936-8.422C369.781,453.962,356.755,443.733,341.333,443.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B233"
    },
    d: "M256,204.8H5.126C1.767,221.343,0,238.466,0,256s1.767,34.657,5.126,51.2H256  c28.277,0,51.2-22.923,51.2-51.2S284.277,204.8,256,204.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FB7A5B"
    },
    cx: 469.333,
    cy: 256,
    r: 8.533
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B233"
    },
    cx: 81.249,
    cy: 133.632,
    r: 8.533
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FA9647"
    },
    cx: 435.2,
    cy: 290.133,
    r: 8.533
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.86e3dd3046d1e19e6b443e53ce3049cc.svg";
export { ForwardRef as ReactComponent };